import { MenuItem } from '@mui/material';
import SweepSelect, { SelectSizes } from '../common/SweepSelect';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ConfigurationToName } from '../documentation/salesforce-documentation-card/types';
import { AiAgent } from '../aiAgentCenter/aiAgentsConsts';
import { getAgentMetadataType, isMetadataTypeAgent } from '../aiAgentCenter/helper';
import {
  AI_MONITORING_AGENT_OBJECT_CONTEXT_METADATA_TYPES,
  SalesforceConfigurationType,
} from '@server/ai';
import { getMetadataLabel } from '../documentation/tabs/getMetadataLabel';
import { useRunOnceWhenTruthy } from '../common/useRunOnceWhenTruthy';

const applicableResourceTypesForObjectTypeAgents =
  AI_MONITORING_AGENT_OBJECT_CONTEXT_METADATA_TYPES;

const BestPracticeEditResource = ({
  resourceType,
  setResourceType,
  agent,
}: {
  resourceType?: SalesforceConfigurationType;
  setResourceType: (value: SalesforceConfigurationType) => void;
  agent?: AiAgent | null;
}) => {
  const _isMetadataTypeAgent = isMetadataTypeAgent(agent);
  const agentMetadataType = _isMetadataTypeAgent ? getAgentMetadataType(agent) : null;

  useRunOnceWhenTruthy(() => {
    if (agentMetadataType) {
      setResourceType(agentMetadataType);
    }
  }, _isMetadataTypeAgent);

  return (
    <SweepSelect
      variant={SelectSizes.small}
      SelectProps={{
        placeholder: 'Choose type',
        value: resourceType,
        onChange: (e) => setResourceType(e.target.value as SalesforceConfigurationType),
        renderValue: (value) => (
          <Typography variant="caption" color={colors.grey[900]}>
            {ConfigurationToName[value as SalesforceConfigurationType] ||
              getMetadataLabel(value as string)}
          </Typography>
        ),
      }}
    >
      {/* TODO: add the best practices for the agent of type metadataType */}
      {_isMetadataTypeAgent && agentMetadataType ? (
        <MenuItem key={agentMetadataType} value={agentMetadataType}>
          {getMetadataLabel(agentMetadataType ?? '')}
        </MenuItem>
      ) : (
        applicableResourceTypesForObjectTypeAgents.map((resourceType) => (
          <MenuItem key={resourceType} value={resourceType}>
            {getMetadataLabel(resourceType)}
          </MenuItem>
        ))
      )}
    </SweepSelect>
  );
};
export default BestPracticeEditResource;
